const Router = {
  SignIn: '/sign-in',
  Root: '/'
}

export default Router
